import { render, staticRenderFns } from "./AppMenuListMain.vue?vue&type=template&id=522f9883&scoped=true&"
import script from "./AppMenuListMain.vue?vue&type=script&lang=js&"
export * from "./AppMenuListMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMenuListMain.vue?vue&type=style&index=0&id=522f9883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522f9883",
  null
  
)

export default component.exports